var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Formik } from 'formik';
import { get } from 'lodash';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { displayError, displayMessage } from '../Config/ApplicationConfig';
import { useAsync, UseAsyncStatus } from '../Hooks/useAsync';
import { afterExpiryDate, beforeStartDate, MedicationLocale, requiredField } from '../Medications.en';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { convertValidationResultToErrorsObjectV2, getFirstErrorMessageFromApiError, isDomainValidationError } from '../Shared/DomainValidationFunctions';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { StopMedicationsDialog } from './StopMedicationsDialog';
export var getExpiresOn = function (selected, today, expiresOn) {
    var expiresOnMoment = moment(expiresOn, ValidDateFormats.IsoFormat);
    var expiryBeforeToday = !!expiresOn && expiresOnMoment.isValid() ? expiresOnMoment.isBefore(today, 'day') : false;
    var stoppedDate = expiryBeforeToday ? expiresOnMoment : today;
    if (selected) {
        return stoppedDate.format(ValidDateFormats.IsoFormat);
    }
    else {
        return expiresOnMoment.isValid() ? expiresOnMoment.format(ValidDateFormats.IsoFormat) : '';
    }
};
export var getPerformedOn = function (today, performedOn) {
    var performedOnMoment = moment(performedOn, ValidDateFormats.IsoFormat);
    var startAfterToday = !!performedOn && performedOnMoment.isValid() ? performedOnMoment.isAfter(today, 'day') : false;
    var startedDate = startAfterToday ? today : performedOnMoment;
    return startedDate.format(ValidDateFormats.IsoFormat);
};
export var stopMedicationsSchema = yup.object({
    medications: yup.array().of(yup.object({
        medication: yup.object(),
        reason: yup.string(),
        selected: yup.bool(),
        expiresOn: yup.string().when('selected', {
            is: function (value) { return value; },
            then: yup
                .string()
                .test({
                name: 'performed-date-check',
                message: beforeStartDate,
                test: function (value) {
                    var performedOn = getPerformedOn(moment(), get(this.parent, 'medication.performedOn'));
                    var valueMoment = moment(value, ValidDateFormats.IsoFormat);
                    return moment(performedOn, ValidDateFormats.IsoFormat).isSameOrBefore(valueMoment, 'day');
                }
            })
                .test({
                name: 'expiry-date-check',
                message: afterExpiryDate,
                test: function (value) {
                    var expiresOn = get(this.parent, 'medication.expiresOn');
                    if (expiresOn) {
                        var valueMoment = moment(value, ValidDateFormats.IsoFormat);
                        var expiresOnMoment = moment(expiresOn, ValidDateFormats.IsoFormat);
                        return valueMoment.isSameOrBefore(expiresOnMoment, 'day');
                    }
                    return true;
                }
            })
                .required(requiredField)
        })
    }))
});
export var StopMedication = function (props) {
    var _a, _b;
    var httpConfig = useHttpConfig();
    var _c = __read(useState(true), 2), showStopMedicationsDialog = _c[0], setShowStopMedicationsDialog = _c[1];
    var noSelectedMedicationId = props.selectedId === undefined;
    var medicationsToStopAsync = useAsync({
        defaultValue: [],
        httpConfig: httpConfig,
        getApi: props.getMedicationToStop
    });
    function getMedication() {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, medicationsToStopAsync.getApi()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        getMedication();
    }, []);
    var showError = function (err, value, actions) {
        var errorMessage = 'Unable to stop medications';
        if (isDomainValidationError(err)) {
            if (err.content) {
                var errors = convertValidationResultToErrorsObjectV2(err.content, MedicationLocale, function (propertyName) {
                    if (propertyName.startsWith('MedicationStoppedDate:')) {
                        for (var i = 0; i < value.medications.length; i++) {
                            if ("MedicationStoppedDate:" + value.medications[i].medication.id === propertyName)
                                return "medications[" + i + "].expiresOn";
                        }
                    }
                    return propertyName;
                });
                actions.setErrors(errors.fieldErrors);
            }
            errorMessage = getFirstErrorMessageFromApiError(err, MedicationLocale);
        }
        displayError(errorMessage);
        setShowStopMedicationsDialog(true);
    };
    if (medicationsToStopAsync.status === UseAsyncStatus.Loaded) {
        return (React.createElement(Formik, { initialValues: {
                medications: (_b = (_a = medicationsToStopAsync.data) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                    var selected = noSelectedMedicationId ? false : x.id === props.selectedId;
                    return {
                        medication: x,
                        reason: '',
                        expiresOn: getExpiresOn(selected, moment(), x.expiresOn),
                        selected: selected
                    };
                })) !== null && _b !== void 0 ? _b : []
            }, validationSchema: stopMedicationsSchema, onSubmit: function (value, actions) { return __awaiter(void 0, void 0, void 0, function () {
                var selectedMedications, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            actions.setSubmitting(true);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            selectedMedications = value.medications
                                .filter(function (x) { return x.selected; })
                                .map(function (x) { return ({
                                medication: __assign({}, x.medication),
                                reason: x.reason,
                                expiresOn: moment(x.expiresOn).format(ValidDateFormats.IsoFormat),
                                stoppedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone)
                            }); });
                            return [4 /*yield*/, props.saveMedicationsToStop({ medications: selectedMedications })];
                        case 2:
                            _a.sent();
                            displayMessage(selectedMedications.length > 1 ? 'Medications stopped' : 'Medication stopped');
                            props.onComplete();
                            return [3 /*break*/, 4];
                        case 3:
                            err_2 = _a.sent();
                            showError(err_2, value, actions);
                            actions.setSubmitting(false);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); } }, function (formProps) {
            return (React.createElement(React.Fragment, null, showStopMedicationsDialog && (React.createElement(StopMedicationsDialog, __assign({}, formProps, { bulkSelectionMode: noSelectedMedicationId, onCancel: props.onCancel, onComplete: function () {
                    setShowStopMedicationsDialog(false);
                    formProps.submitForm();
                } })))));
        }));
    }
    else {
        return null;
    }
};
